<template>
  <div
    class="overflow-hidden bg-gradient-to-b dark:(from-[#1A1C1F] to-[#1A1C1F]/0) light:(from-[#E8EBF2] to-[#E8EBF2]/0)"
  >
    <div class="h-89 md:(px-1/10 h-125) w-full relative">
      <div class="w-full h-full flex justify-center items-center md:(flex-nowrap justify-between)">
        <div class="w-full h-full z-10">
          <div
            v-if="!authStore.isLoggedIn"
            class="w-full h-full flex flex-col items-center gap-2 md:(items-start gap-4 bottom-0 relative) py-10 absolute -bottom-30"
          >
            <div class="text-sm md:text-xl dark:text-white light:text-light-text mt-10">
              가입 첫 충전
            </div>
            <div class="dark:text-white light:text-light-text text-3xl md:text-6xl font-bold">
              <span class="bg-clip-text text-transparent bg-gradient-to-r from-[#B4E817] to-[#44C00F]">보너스 30%</span>
            </div>
            <div class="w-full px-10 mt-1 md:(px-0 mt-5)">
              <QBtn
                unelevated
                label="가입하기"
                text-color="white"
                class="bg-gradient-primary h-12 w-full md:w-40"
                @click="authStore.showLoginModal = true"
              />
            </div>
          </div>
          <div
            v-else
            class="w-full h-full flex flex-col items-center md:(items-start gap-4 relative bottom-0) py-10 absolute -bottom-40"
          >
            <div class="text-sm dark:text-dark-text light:text-light-text">
              안녕하세요 <span class="dark:text-white light:text-black">{{ authStore.user.nickname }}</span> 환영합니다!
            </div>
            <div class="text-3xl font-bold dark:text-white light:text-black">
              매번 충전 보너스
            </div>
            <div
              class="text-3xl md:text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-[#B4E817] to-[#44C00F]"
            >
              +10% 추가 지급
            </div>
            <div class="flex items-center flex-nowrap justify-between gap-2 mt-2 md:(justify-start gap-5 mt-5)">
              <QBtn
                :to="{name: 'deposits'}"
                unelevated
                text-color="white"
                label="입금하기"
                class="h-10 md:h-12 w-40 bg-gradient-secondary"
              />
              <QBtn
                :to="{name: 'questions.create'}"
                unelevated
                text-color="white"
                label="문의하기"
                class="h-10 md:h-12 w-40 bg-gradient-primary"
              />
            </div>
          </div>
        </div>
        <div class="absolute z-1 w-3/2 top-0 md:(relative right-0)">
          <img
            :src="$q.dark.isActive ? bannerDark : bannerLight"
            class="h-89 md:h-125"
          >
        </div>
      </div>
      <div
        v-if="$q.screen.gt.sm"
        class="z-20 absolute left-0 bottom-0 overflow-hidden w-full px-1/10"
      >
        <div class="relative flex flex-nowrap items-center">
          <QBtn
            icon="chevron_left"
            unelevated
            flat
            dense
            class="dark:bg-dark-2 light:bg-light-2 absolute -left-7"
            @click="swiper.slidePrev(1200)"
          />
          <Swiper
            :loop="true"
            space-between="10"
            @init="initSwiper"
            @slideChange="onSlideChange"
          >
            <SwiperSlide v-for="items in banners">
              <div class="grid grid-cols-3 gap-2">
                <RouterLink
                  v-for="banner in items"
                  :to="banner.route"
                  class="rounded-3xl overflow-hidden"
                >
                  <img
                    :src="banner.img"
                    alt=""
                  >
                </RouterLink>
              </div>
            </SwiperSlide>
          </Swiper>
          <QBtn
            icon="chevron_right"
            unelevated
            flat
            dense
            class="dark:bg-dark-2 light:bg-light-2 absolute -right-7"
            @click="swiper.slideNext(1200)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import bannerDark from '@/assets/home/banner-dark.png'
import bannerLight from '@/assets/home/banner-light.png'
import {useAuthStore} from '@/stores/auth'
import banner1 from '@/assets/home/banners/banner-1.png'
import banner2 from '@/assets/home/banners/banner-2.png'
import banner3 from '@/assets/home/banners/banner-3.png'
import banner4 from '@/assets/home/banners/banner-4.png'
import banner5 from '@/assets/home/banners/banner-5.png'
import banner6 from '@/assets/home/banners/banner-6.png'
import banner7 from '@/assets/home/banners/banner-7.png'
import banner8 from '@/assets/home/banners/banner-8.png'
import banner9 from '@/assets/home/banners/banner-9.png'
import banner10 from '@/assets/home/banners/banner-10.png'
import banner11 from '@/assets/home/banners/banner-11.png'
import banner12 from '@/assets/home/banners/banner-12.png'
import {Swiper, SwiperSlide} from 'swiper/vue'
import 'swiper/css'
import {ref} from 'vue'
import {useCycleList} from '@vueuse/core'

const authStore = useAuthStore()
const banners = [
  [
    {
      img: banner1,
      route: { name: 'events.show', params: { event: 48 }}
    },
    {
      img: banner2,
      route: { name: 'events' }
    },
    {
      img: banner3,
      route: { name: 'events.show', params: { event: 54 }}
    },
  ],
  [
    {
      img: banner4,
      route: { name: 'events' }
    },
    {
      img: banner5,
      route: { name: 'events.show', params: { event: 49 }}
    },
    {
      img: banner6,
      route: { name: 'events.show', params: { event: 50 }}
    },
  ],
  [
    {
      img: banner7,
      route: { name: 'events.show', params: { event: 52 }}
    },
    {
      img: banner8,
      route: { name: 'events.show', params: { event: 51 }}
    },
    {
      img: banner9,
      route: { name: 'events.show', params: { event: 45 }}
    },
  ],
  [
    {
      img: banner10,
      route: { name: 'events.show', params: { event: 46 }}
    },
    {
      img: banner11,
      route: { name: 'events' }
    },
    {
      img: banner12,
      route: { name: 'events.show', params: { event: 53 }}
    },
  ],
]

const swiper = ref(null)

const {index} = useCycleList(banners)

function initSwiper(instance) {
  swiper.value = instance
}

function onSlideChange(instance) {
  index.value = instance.activeIndex
}
</script>
